import { isDefined } from "@clipboard-health/util-ts";

import { CbhCustomChatMessage } from "./CbhCustomChatMessage";
import { type RenderCustomMessageProps } from "./type";
import { parseShiftInviteChatMessage } from "./utils";

export function ShiftInviteResponseMessage(props: RenderCustomMessageProps) {
  const { facilityMessage } = parseShiftInviteChatMessage(props);
  return isDefined(facilityMessage) ? <CbhCustomChatMessage message={facilityMessage} /> : null;
}
